var Router = {
  ReplaceState(url, data) {
    var query = this.Generate(data);
    window.history.replaceState(url, "", query);
  },

  /**
   * 生成url
   */
  Generate(data) {
    var search = "?";
    for (var temp in data) {
      search += `${temp}=${data[temp]}&`;
    }
    search = search.substr(0, search.length - 1);
    return search;
  },

  /**
   * 解析search
   */
  UrlSearch(key) {
    var search = window.location.search;
    if (search) {
      var searchObject = {};
      var queries = search.replace(/^\?/, "").split("&");
      for (var i = 0; i < queries.length; i++) {
        var split = queries[i].split("=");
        if (split[0] != "" && split[1] !== undefined) {
          searchObject[split[0]] = decodeURIComponent(split[1]);
        }
      }
      if (key) {
        return searchObject[key];
      } else {
        return searchObject;
      }
    } else {
      return "";
    }
  },
  /**
   * 解析ali search
   */
  UrlSearchAli(key) {
    var search = window.location.hash;
    search = search.slice(search.indexOf("?"));
    if (search) {
      var searchObject = {};
      var queries = search.replace(/^\?/, "").split("&");
      for (var i = 0; i < queries.length; i++) {
        var split = queries[i].split("=");
        if (split[0] != "" && split[1] !== undefined) {
          searchObject[split[0]] = decodeURIComponent(split[1]);
        }
      }
      if (key) {
        return searchObject[key];
      } else {
        return searchObject;
      }
    } else {
      return "";
    }
  },
  //判断是否是微信
  isWeichat() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  //判断是否云助理
  isYzl() {
    var ua = navigator.userAgent.toLowerCase();
    if (/yunzhuli/.test(ua)) {
      return true;
    } else {
      return false;
    }
  },
  //判断图片格式和大小
  validateImg(ele) {
    let fileName = ele.name
      .substring(ele.name.lastIndexOf(".") + 1)
      .toLowerCase();
    if (fileName == "gif") {
      alert("上传图片格式不正确，请重新上传");
      return false;
    } else if (ele.size.toFixed(2) >= 1024 * 1024 * 3) {
      alert("请上传小于3MB的图片");
      return false;
    } else {
      return true;
    }
  },
  intToChinese(str) {
    str = str + "";
    var len = str.length - 1;
    var idxs = [
      "",
      "十",
      "百",
      "千",
      "万",
      "十",
      "百",
      "千",
      "亿",
      "十",
      "百",
      "千",
      "万",
      "十",
      "百",
      "千",
      "亿"
    ];
    var num = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    return str.replace(/([1-9]|0+)/g, function($, $1, idx, full) {
      var pos = 0;
      if ($1[0] != "0") {
        pos = len - idx;
        if (idx == 0 && $1[0] == 1 && idxs[len - idx] == "十") {
          return idxs[len - idx];
        }
        return num[$1[0]] + idxs[len - idx];
      } else {
        var left = len - idx;
        var right = len - idx + $1.length;
        if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
          pos = left - (left % 4);
        }
        if (pos) {
          return idxs[pos] + num[$1[0]];
        } else if (idx + $1.length >= len) {
          return "";
        } else {
          return num[$1[0]];
        }
      }
    });
  }
};
export default Router;



// WEBPACK FOOTER //
// ./src/util/replaceState.js